import { useState } from 'react';
import { WorkspaceIcon } from './icons';

export const connectionLogoUrl = (id: string) => {
  const logo = id.startsWith('pipedream:') ? id.slice('pipedream:'.length) : id;
  const known: Record<string, string> = {
    'meta-ads-mcp': 'meta-ads',
    gmail: 'google-workspace',
    google_calendar: 'google-workspace',
    google_drive: 'google-workspace',
  };
  return `/connector-logos/${encodeURIComponent(known[logo] ?? logo)}.svg`;
};

/** Only local assets; unfamiliar apps retain their name and a neutral mark. */
export function ConnectionLogo({ id, name }: { id: string; name: string }) {
  const [failed, setFailed] = useState(false);
  return (
    <span className="ws-home-app-logo" title={name}>
      {failed ? (
        <WorkspaceIcon name="connections" size={16} />
      ) : (
        <img src={connectionLogoUrl(id)} alt={name} onError={() => setFailed(true)} />
      )}
    </span>
  );
}
